import type { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

export type ControlPlaneSurfaceVariant = 'default' | 'elevated' | 'inset' | 'transparent';

export interface ControlPlaneSurfaceProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: ControlPlaneSurfaceVariant;
  interactive?: boolean;
  noPadding?: boolean;
}

export function ControlPlaneSurface({
  children,
  variant = 'default',
  interactive = false,
  noPadding = false,
  className,
  ...rest
}: ControlPlaneSurfaceProps) {
  return (
    <div
      {...rest}
      className={clsx(
        'vania-control-plane-surface',
        `vania-control-plane-surface--${variant}`,
        interactive && 'vania-control-plane-surface--interactive',
        noPadding && 'vania-control-plane-surface--no-padding',
        className,
      )}
    >
      {children}
    </div>
  );
}
